import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.userAccess.DOC}
  query SurveyAdmins(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                surveyAdmins {
                  ...FragmentSpaceUserAccess
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SurveyAdminsQuery,
    ents.extra.space.User.Access[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'surveyAdmins',
                graphql.transformers.OUT.list(
                  fragments.userAccess.TRANSFORMER,
                  {
                    onNullish: 'remove',
                  },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.SurveyAdminsQuery,
  ents.extra.space.User.Access[],
  graphql.schema.SurveyAdminsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
